import React from 'react';
import { Shield, Heart, Users, CheckCircle2, Award, Home } from 'lucide-react';

const TrustBadges = () => {
  const badges = [
    {
      icon: CheckCircle2,
      title: '100% Satisfaction Guaranteed',
      description: 'We\'re not happy until you\'re thrilled with your garage. Backed by our complete satisfaction guarantee.'
    },
    {
      icon: Shield,
      title: 'Licensed & Insured',
      description: 'Fully permitted with business tax receipt and comprehensive insurance for your complete protection.'
    },
    {
      icon: Users,
      title: 'Background-Checked Team',
      description: 'All team members are thoroughly vetted and background checked for your peace of mind.'
    },
    {
      icon: Home,
      title: 'Locally Owned & Operated',
      description: 'Brother-sister duo born and raised in Florida, proudly serving Winter Park and surrounding areas.'
    },
    {
      icon: Heart,
      title: 'We Love What We Do',
      description: 'Our passion for organization shows in every project. We bring Florida grit and satisfaction to every garage.'
    },
    {
      icon: Award,
      title: 'Professional & Reliable',
      description: 'Punctual, respectful, and committed to delivering exceptional results every single time.'
    }
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Why One Clean Garage is the Perfect Choice
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            We're committed to providing exceptional garage cleaning and organization services you can trust
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {badges.map((badge, index) => {
            const Icon = badge.icon;
            return (
              <div 
                key={index}
                className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-xl border-2 border-slate-200 hover:border-emerald-500 hover:shadow-xl transition-all duration-300"
              >
                <div className="bg-emerald-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                  <Icon className="h-8 w-8 text-emerald-600" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">{badge.title}</h3>
                <p className="text-slate-600 leading-relaxed">{badge.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;